import React, { useState } from 'react';
import { ChartBar } from '@phosphor-icons/react';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import DashboardModal from './DashboardModal';
import { UtilityDetailsCard } from './UtilityDetailsCard';
import './oneButton-css/UtilityDetailsPopupModal.css';

export type UtilityDetailsPopupModalProps = {
    open: boolean;
    onClose: () => void;
};

export const UtilityDetailsPopupModal: React.FC<UtilityDetailsPopupModalProps> = ({ open, onClose }) => {
    const theme = useOneButtonStore((s) => s.theme);
    const utilityDetailsDirty = useOneButtonStore((s) => s.utilityDetailsDirty);
    const [headerActions, setHeaderActions] = useState<React.ReactNode>(null);

    return (
        <DashboardModal
            open={open}
            onClose={onClose}
            title={
                <span className="obd-utility-details-popup__title">
                    <ChartBar size={18} weight="duotone" className="obd-utility-details-popup__title-icon" aria-hidden />
                    Utility Details
                    {utilityDetailsDirty ? (
                        <span
                            className="obd-utility__unsaved-chip obd-utility-details-popup__unsaved"
                            title="You have unsaved changes. Open Utility details and click Save."
                        >
                            Unsaved
                        </span>
                    ) : null}
                </span>
            }
            headerActions={headerActions}
            width="min(1120px, calc(100vw - 40px))"
            centered
            destroyOnClose
            maskClosable
            theme={theme}
            className="obd-utility-details-popup-modal"
            rootClassName="obd-utility-details-popup-modal-root"
            footer={null}
        >
            <UtilityDetailsCard presentation="popup" onPopupToolbar={setHeaderActions} />
        </DashboardModal>
    );
};

export default UtilityDetailsPopupModal;
